import useTranslations from "@/shared/lang/useTranslations";
import type { BrebReceivingKey } from "@/shared/services/payments/brebReceivingKey.service";
import { formatLimitAmount } from "@/shared/utils/amountLimits";

/** The key's accepted range in one line, or undefined when it carries no bound. */
export function useBrebKeyRangeLabel(receivingKey: BrebReceivingKey): string | undefined {
  const { t, activeLanguage } = useTranslations("payins");
  if (receivingKey.status === "PENDING") return undefined;
  const format = (value: string) => formatLimitAmount(value, "COP", activeLanguage);
  const { min_amount: min, max_amount: max } = receivingKey;
  if (min && max) return t("amount_limit_hint_range", { min: format(min), max: format(max) });
  if (min) return t("amount_limit_hint_min", { min: format(min) });
  if (max) return t("amount_limit_hint_max", { max: format(max) });
  return undefined;
}
